var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c(
        "div",
        { staticClass: "btns" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small", icon: "el-icon-back" },
              on: {
                click: function($event) {
                  return _vm.$router.back(-1)
                }
              }
            },
            [_vm._v("返回")]
          ),
          _c(
            "el-dropdown",
            {
              staticClass: "dropdown",
              attrs: { trigger: "click" },
              on: { command: _vm.handleCommandCompany }
            },
            [
              _c("el-button", { attrs: { size: "small", type: "primary" } }, [
                _vm._v("\n        设置公章"),
                _c("i", { staticClass: "el-icon-arrow-down el-icon--right" })
              ]),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                _vm._l(_vm.newPdfImgs, function(item, index) {
                  return _c(
                    "el-dropdown-item",
                    { key: index + "b", attrs: { command: index } },
                    [_vm._v("添加到第" + _vm._s(index + 1) + "页")]
                  )
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-dropdown",
            {
              staticClass: "dropdown",
              attrs: { trigger: "click" },
              on: { command: _vm.handleCommandPerson }
            },
            [
              _c("el-button", { attrs: { size: "small", type: "primary" } }, [
                _vm._v("\n        设置设置个人章"),
                _c("i", { staticClass: "el-icon-arrow-down el-icon--right" })
              ]),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                _vm._l(_vm.newPdfImgs, function(item, index) {
                  return _c(
                    "el-dropdown-item",
                    { key: index + "b", attrs: { command: index } },
                    [_vm._v("添加到第" + _vm._s(index + 1) + "页")]
                  )
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-button",
            {
              attrs: {
                size: "small",
                type: "primary",
                loading: _vm.btnLoading
              },
              on: { click: _vm.confirm }
            },
            [_vm._v("确定")]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flex-box" },
        _vm._l(_vm.newPdfImgs, function(item, index) {
          return _c(
            "div",
            {
              key: index + "a",
              ref: "imgView",
              refInFor: true,
              staticClass: "img-view"
            },
            [
              _c("img", {
                staticClass: "img",
                attrs: { src: item.src, alt: "" }
              }),
              item.seal_p
                ? _c("Seal", {
                    attrs: {
                      type: "seal_p",
                      left: _vm.pLeft,
                      top: _vm.pTop,
                      maxWidth: item.maxWidth,
                      maxHeight: item.maxHeight,
                      src: _vm.signature.personSign,
                      index: index
                    },
                    on: { sendCoordinate: _vm.receiveCoordinatePerson }
                  })
                : _vm._e(),
              item.seal_c
                ? _c("Seal", {
                    attrs: {
                      type: "seal_c",
                      left: _vm.cLeft,
                      top: _vm.cTop,
                      maxWidth: item.maxWidth,
                      maxHeight: item.maxHeight,
                      src: _vm.signature.canpanySign,
                      index: index
                    },
                    on: { sendCoordinate: _vm.receiveCoordinateCompany }
                  })
                : _vm._e()
            ],
            1
          )
        }),
        0
      ),
      _c("VerifyPassword", {
        ref: "verifyPassword",
        on: { checkSuccess: _vm.onSeal }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }